export function computeDaysInShelter(intakeDate: string | null): number | null {
  if (!intakeDate) return null;
  const intake = new Date(intakeDate);
  if (Number.isNaN(intake.getTime())) return null;
  const now = new Date();
  return Math.max(0, Math.floor((now.getTime() - intake.getTime()) / 86400000));
}

export function getDaysInShelterColor(days: number): string {
  if (days > 60) return "text-destructive";
  if (days > 30) return "text-amber-600 dark:text-amber-500";
  return "text-muted-foreground";
}
